import { connect } from 'react-redux'

import NonAuthenticatedLayout from '../components'
import { showNotification, hideNotification } from '../../../store/global'

const mapStateToProps = state => ({
  ...state.global,
  theme: state.theme
})

const mapDispatchToProps = {
  showNotification,
  hideNotification
}

const NonAuthenticatedContainer = connect(mapStateToProps, mapDispatchToProps)(
  NonAuthenticatedLayout
)

export default NonAuthenticatedContainer



// WEBPACK FOOTER //
// ./src/layouts/NonAuthenticated/containers/index.js